import { render, staticRenderFns } from "./VideoStatistics.vue?vue&type=template&id=d975607e&scoped=true"
import script from "./VideoStatistics.js?vue&type=script&lang=js&external"
export * from "./VideoStatistics.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d975607e",
  null
  
)

export default component.exports